var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.writeLayouts),function(writeLayout){return _c('board-write-link',{key:`boardCategory${writeLayout}`,attrs:{"writeLayout":writeLayout,"boardData":_vm.boardData}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }